import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const formatearCuenta = (ms) => {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":");
};

/**
 * Límite diario de consultas a la IA (services/asistente/limite.js en el back).
 * - Agotado: sustituye a la caja de texto con la cuenta atrás hasta medianoche (hora de Madrid). Al llegar a cero llama a
 *   onReinicio para volver a pedir el estado. Con plan Élite recuerda que el Chat Élite lo atienden personas.
 * - Quedan pocas (5 o menos): aviso pequeño sobre la caja de texto.
 * @param {{ limite: { limite, restantes, agotado, reinicio } | null, conChatElite?: boolean, onReinicio?: () => void, t }} props
 */
export default function LAEAILimite({ limite, conChatElite = false, onReinicio, t }) {
  const [ahora, setAhora] = useState(Date.now());
  const agotado = !!limite?.agotado;
  const reinicio = limite?.reinicio ? new Date(limite.reinicio).getTime() : null;

  useEffect(() => {
    if (!agotado || !reinicio) return undefined;
    const id = setInterval(() => {
      const t0 = Date.now();
      setAhora(t0);
      if (t0 >= reinicio) {
        clearInterval(id);
        onReinicio?.();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [agotado, reinicio, onReinicio]);

  if (!limite || limite.limite == null) return null;

  if (agotado) {
    return (
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" role="status">
        <Clock size={18} className="mt-0.5 shrink-0 text-amber-600" />
        <div className="min-w-0">
          <p className="m-0 font-semibold">{t("laeai.limite.titulo")}</p>
          <p className="m-0 mt-1">
            {t("laeai.limite.texto", { limite: limite.limite })}{" "}
            {reinicio && (
              <>
                {t("laeai.limite.vuelve")}{" "}
                <span className="font-semibold tabular-nums">{formatearCuenta(reinicio - ahora)}</span>
              </>
            )}
          </p>
          {conChatElite && <p className="m-0 mt-1 text-amber-800">{t("laeai.limite.chatElite")}</p>}
        </div>
      </div>
    );
  }

  if (limite.restantes != null && limite.restantes <= 5) {
    return (
      <p className="mx-auto mb-1 max-w-3xl text-right text-[11px] text-gray-500">
        {t("laeai.limite.quedan", { count: limite.restantes })}
      </p>
    );
  }
  return null;
}
